declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'
 

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const appRouters: Array<Router> = [{
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
        { path: 'user', permission: 'Pages.Users', meta: { title: 'Users' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
        { path: 'role', permission: 'Pages.Roles', meta: { title: 'Roles' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
        { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') }
    ]
},
{
    path: '/companyinformation',
    name: 'companyinformationmsg',
    permission: '',
    meta: { title: 'CompanyInformationMenu' },
    icon: '&#xe65d;',
    component: main,
    children: [
        { path: 'companyinformation', permission: 'Pages.CompanyInformation', meta: { title: 'CompanyInformation' }, name: 'companyinformation', component: () => import('../views/companyinformation/companyinformation.vue') },
        
    ]
},
{
    path: '/wastetype',
    name: 'wastetypemsg',
    permission: '',
    meta: { title: 'WasteTypeMenu' },
    icon: '&#xe65f;',
    component: main,
    children: [
        { path: 'wastetype', permission: 'Pages.WasteType', meta: { title: 'WasteType' }, name: 'wastetype', component: () => import('../views/wastetype/wastetype.vue') },
        
    ]
}, 

 // { path: 'ordstatisticsdatatime', permission: 'Pages.OrderManagement_StatisticsDataTime', meta: { title: 'OrderManagement_StatisticsDataTime' }, name: 'ordstatisticsdatatime', component: () => import('../views/ordermanagement/ordstatisticsdatatime.vue') },

{
    path: '/ordermanagement',
    name: 'ordermanagementmsg',
    permission: '',
    meta: { title: 'OrderManagementMenu' },
    icon: '&#xe64b;',
    component: main,
    children: [
      //   { path: 'ordermanagement', permission: 'Pages.OrderManagement', meta: { title: 'OrderManagement' }, name: 'ordermanagement', component: () => import('../views/ordermanagement/ordermanagement.vue') },
        { path: 'ordermanagementwarehousing', permission: 'Pages.OrderManagement_Warehousing', meta: { title: 'OrderManagement_Warehousing' }, name: 'ordermanagementwarehousing', component: () => import('../views/ordermanagement/ordermanagementwarehousing.vue') },
        { path: 'ordermanagementdrying', permission: 'Pages.OrderManagement_Drying', meta: { title: 'OrderManagement_Drying' }, name: 'ordermanagementdrying', component: () => import('../views/ordermanagement/ordermanagementdrying.vue') },
        { path: 'ordermanagementoutbound', permission: 'Pages.OrderManagement_Outbound', meta: { title: 'OrderManagement_Outbound' }, name: 'ordermanagementoutbound', component: () => import('../views/ordermanagement/ordermanagementoutbound.vue') },
    
      
    ]
},
{
    path: '/ordermanagement',
    name: 'ordstatisticsdatatimemsg',
    permission: '',
    meta: { title: 'OrdDataTimeMenu' },
    icon: '&#xe60b;',
    component: main,
    children: [
      //   { path: 'ordermanagement', permission: 'Pages.OrderManagement', meta: { title: 'OrderManagement' }, name: 'ordermanagement', component: () => import('../views/ordermanagement/ordermanagement.vue') },
      { path: 'ordstatisticsdatatime_warehousing', permission: 'Pages.OrdStatisticsDataTime_Warehousing', meta: { title: 'OrdStatisticsDataTime_Warehousing' }, name: 'ordstatisticsdatatime_warehousing', component: () => import('../views/ordermanagement/ordstatisticsdatatime_warehousing.vue') },
      { path: 'ordstatisticsdatatime_drying', permission: 'Pages.OrdStatisticsDataTime_Drying', meta: { title: 'OrdStatisticsDataTime_Drying' }, name: 'ordstatisticsdatatime_drying', component: () => import('../views/ordermanagement/ordstatisticsdatatime_drying.vue') },
      { path: 'ordstatisticsdatatime_outbound', permission: 'Pages.OrdStatisticsDataTime_Outbound', meta: { title: 'OrdStatisticsDataTime_Outbound' }, name: 'ordstatisticsdatatime_outbound', component: () => import('../views/ordermanagement/ordstatisticsdatatime_outbound.vue') },

    
       // { path: 'ordstatisticsdatatime', permission: 'Pages.OrderManagement_StatisticsDataTime', meta: { title: 'OrderManagement_StatisticsDataTime' }, name: 'ordstatisticsdatatime', component: () => import('../views/ordermanagement/ordstatisticsdatatime.vue') },
    ]
  
},
{
    path: '/ordermanagementdispose',
    name: 'ordermanagementdisposemsg',
    permission: '',
    meta: { title: 'OrderManagementDisposeMenu' },
    icon: '&#xe65d;',
    component: main,
    children: [
        { path: 'ordermanagementdispose', permission: 'Pages.OrderManagementDispose', meta: { title: 'OrderManagementDispose' }, name: 'ordermanagementdispose', component: () => import('../views/ordermanagement/ordermanagementdispose.vue') },
        
    ]
}
,
{
    path: '/ordstatisticsdatatimeend',
    name: 'ordstatisticsdatatimeendmsg',
    permission: '',
    meta: { title: 'OrdDataTimeEndMenu' },
    icon: '&#xe66d;',
    component: main,
    children: [

        { path: 'ordstatisticsdatatimeend', permission: 'Pages.OrderManagement_StatisticsDataTime', meta: { title: 'OrderManagement_StatisticsDataTime' }, name: 'ordstatisticsdatatimeend', component: () => import('../views/ordermanagement/ordstatisticsdatatime.vue') },

        
    ]
}

 
]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
